export const reviewFieldTypes = {
    text: "Text",
    boolean: "Boolean",
    numeric: "Numeric",
    range: "Range",
    rating: "Rating",
}